export default __webpack_public_path__ + "media/images/icons_fc/doc_time-9fb9c50505e1b1dbfa32444d0d31048d.png";